export default function Separate() {
  return <div className="w-full h-[1px] bg-[rgba(255,255,255,0.15)]" data-sentry-component="Separate" data-sentry-source-file="index.tsx" />;
}